/* Zeprado - szybki wybor rozmiaru i dodanie do koszyka prosto z kafelka w liscie produktow.
   Plik agenta: szybkie-dodawanie. Bez bibliotek zewnetrznych.
   Wlasciciel plikow: assets/zp-szybki-wybor.js + snippets/zp-szybki-wybor.liquid.
   Nie modyfikuje kart w Liquidzie - panel jest doklejany do DOM po stronie przegladarki,
   dzieki czemu przy wylaczonym JS zostaje natywny przycisk motywu ("Wybierz"). */

let Zdarzenia = null;
try {
  Zdarzenia = await import('@shopify/events');
} catch (e) {
  Zdarzenia = null;
}

(function () {
  'use strict';
  if (window.__zpSzybkiWybor) return;
  window.__zpSzybkiWybor = true;

  var CACHE = 'zp_sw_p1:';
  var CACHE_MR = 'zp_mr_p1:'; /* cache agenta "moj rozmiar" - ten sam zestaw danych */
  var ROWNOLEGLE = 6;
  var UNI = { '': 1, 'DEFAULT TITLE': 1, 'DEFAULTTITLE': 1, 'ONE SIZE': 1, 'ONESIZE': 1, 'UNI': 1, 'UNIWERSALNY': 1 };

  var T = {
    rozmiar: 'Rozmiar',
    wybierz: 'Wybierz rozmiar',
    dodaj: 'Dodaj do koszyka',
    dodajKrotko: 'Dodaj',
    dodano: 'Dodano do koszyka',
    brakRozmiaru: 'Tego rozmiaru chwilowo nie ma',
    wyprzedane: 'Wyprzedane',
    ladowanie: 'Sprawdzam dostępne rozmiary…',
    bladSieci: 'Brak połączenia. Spróbuj jeszcze raz.',
    bladOgolny: 'Nie udało się dodać do koszyka. Spróbuj jeszcze raz.',
    bladDanych: 'Nie udało się wczytać rozmiarów. Otwórz kartę produktu.',
    zamknij: 'Zamknij wybór rozmiaru',
    twoj: 'Twój rozmiar'
  };

  /* -------------------------------------------------------------- narzedzia */

  function trasa(nazwa, zapas) {
    try {
      if (typeof Theme !== 'undefined' && Theme && Theme.routes && Theme.routes[nazwa]) return Theme.routes[nazwa];
    } catch (e) { /* brak globalnego Theme */ }
    return zapas;
  }

  function tekst(el, s) { el.textContent = s == null ? '' : String(s); }

  function uniwersalny(r) {
    return UNI[String(r == null ? '' : r).trim().toUpperCase()] === 1;
  }

  /* ------------------------------------------------------------ dane produktu */

  var pamiec = {};

  function zPamieci(handle) {
    if (pamiec[handle]) return pamiec[handle];
    var s = null;
    try { s = sessionStorage.getItem(CACHE + handle); } catch (e) { s = null; }
    if (s) {
      try { pamiec[handle] = JSON.parse(s); return pamiec[handle]; } catch (e) { /* uszkodzony wpis */ }
    }
    /* awaryjnie: cache agenta "moj rozmiar" ma te same pola (typ + [rozmiar, dostepnosc, id]) */
    try {
      var m = sessionStorage.getItem(CACHE_MR + handle);
      if (m) {
        var o = JSON.parse(m);
        if (o && o.v && o.v.length) {
          pamiec[handle] = { t: o.t || '', o: T.rozmiar, v: o.v };
          return pamiec[handle];
        }
      }
    } catch (e) { /* brak sessionStorage */ }
    return null;
  }

  function doPamieci(handle, dane) {
    pamiec[handle] = dane;
    try { sessionStorage.setItem(CACHE + handle, JSON.stringify(dane)); } catch (e) { /* limit / tryb prywatny */ }
  }

  /* wybiera opcje "Rozmiar", a gdy jej nie ma - pierwsza opcje produktu */
  function indeksOpcji(prod) {
    var i, n;
    if (prod.options && prod.options.length) {
      for (i = 0; i < prod.options.length; i++) {
        n = prod.options[i] && prod.options[i].name ? prod.options[i].name : prod.options[i];
        if (String(n).toLowerCase().indexOf('rozmiar') > -1) return i;
      }
    }
    return 0;
  }

  function nazwaOpcji(prod, idx) {
    var o = prod.options && prod.options[idx];
    var n = o && o.name ? o.name : o;
    n = String(n == null ? '' : n);
    if (!n || n.toLowerCase() === 'title') return T.rozmiar;
    return n;
  }

  function zProduktu(prod) {
    var idx = indeksOpcji(prod);
    return {
      t: prod.type || '',
      o: nazwaOpcji(prod, idx),
      v: (prod.variants || []).map(function (v) {
        var wart = (v.options && v.options[idx] != null) ? v.options[idx] : v.option1;
        var min = (v.quantity_rule && v.quantity_rule.min) ? v.quantity_rule.min : 1;
        return [wart, v.available ? 1 : 0, v.id, min];
      })
    };
  }

  var kolejka = [], biegnie = 0, wDrodze = {};

  function pobierz(handle, gotowe) {
    var c = zPamieci(handle);
    if (c) { gotowe(c); return; }
    if (wDrodze[handle]) { wDrodze[handle].push(gotowe); return; }
    wDrodze[handle] = [gotowe];
    kolejka.push(handle);
    pompuj();
  }

  function rozdaj(handle, dane) {
    var cb = wDrodze[handle] || [];
    delete wDrodze[handle];
    for (var i = 0; i < cb.length; i++) {
      try { cb[i](dane); } catch (e) { /* nic */ }
    }
  }

  function pompuj() {
    while (biegnie < ROWNOLEGLE && kolejka.length) {
      biegnie++;
      (function (handle) {
        fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            var dane = null;
            if (p && p.variants && p.variants.length) {
              dane = zProduktu(p);
              doPamieci(handle, dane);
            }
            biegnie--;
            rozdaj(handle, dane);
            pompuj();
          })
          .catch(function () { biegnie--; rozdaj(handle, null); pompuj(); });
      })(kolejka.shift());
    }
  }

  /* ------------------------------------------------------ integracja "Moj rozmiar" */

  function profilUstawiony() {
    var api = window.zpMojRozmiar;
    if (!api || typeof api.profil !== 'function') return false;
    try {
      var p = api.profil();
      return !!(p && ((p.obwod && p.miseczka) || p.ubranie || p.stopa));
    } catch (e) { return false; }
  }

  /* uzywa logiki agenta "moj rozmiar" (bez jej kopiowania): jeden wariant = jeden rozmiar */
  function tenMojRozmiar(typ, rozmiar) {
    var api = window.zpMojRozmiar;
    if (!api || typeof api.ocen !== 'function' || !profilUstawiony()) return false;
    try {
      return api.ocen({
        type: typ || '',
        options: [{ name: 'Rozmiar' }],
        variants: [{ options: [rozmiar], option1: rozmiar, available: true, id: 0 }]
      }) === 'tak';
    } catch (e) { return false; }
  }

  /* ------------------------------------------------------------------ koszyk */

  function sekcjeKoszyka() {
    var ids = [];
    Array.prototype.forEach.call(document.querySelectorAll('cart-items-component[data-section-id]'), function (el) {
      var s = el.getAttribute('data-section-id');
      if (s && ids.indexOf(s) < 0) ids.push(s);
    });
    return ids;
  }

  function swiezyKoszyk() {
    var k = document.querySelector('cart-items-component');
    if (k && typeof k.fetchCartData === 'function') {
      try { return Promise.resolve(k.fetchCartData()); } catch (e) { /* dalej awaryjnie */ }
    }
    return fetch(trasa('cart_url', '/cart') + '.js', {
      headers: { Accept: 'application/json' }, credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      return r.json();
    });
  }

  function otworzSzuflade() {
    var d = document.getElementById('cart-drawer');
    if (!d) return false;
    var zrob = function () {
      try {
        if (typeof d.open === 'function') { if (!d.isOpen) d.open(); return; }
      } catch (e) { /* nic */ }
    };
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('theme-drawer').then(zrob).catch(function () { /* nic */ });
    } else {
      zrob();
    }
    return true;
  }

  /**
   * Dodaje wariant do koszyka. Zwraca Promise; odrzuca z obiektem {kod, tresc}.
   * Emituje to samo zdarzenie co formularz motywu, wiec licznik koszyka, szuflada
   * i lista pozycji odswiezaja sie same - bez przeladowania strony.
   */
  function dodaj(zrodlo, wariantId, ilosc, produktId) {
    var fd = new FormData();
    fd.append('id', String(wariantId));
    fd.append('quantity', String(ilosc));
    var sek = sekcjeKoszyka();
    if (sek.length) {
      fd.append('sections', sek.join(','));
      fd.append('sections_url', window.location.pathname);
    }

    var Ev = Zdarzenia && Zdarzenia.CartLinesUpdateEvent ? Zdarzenia.CartLinesUpdateEvent : null;
    var odlozone = Ev && typeof Ev.createPromise === 'function' ? Ev.createPromise() : null;

    if (odlozone) {
      try {
        zrodlo.dispatchEvent(new Ev({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(wariantId), quantity: ilosc }],
          promise: odlozone.promise
        }));
      } catch (e) { odlozone = null; }
    }

    function zKoszykiem(odp, blad) {
      if (!odlozone) return Promise.resolve();
      return swiezyKoszyk().then(function (k) {
        odlozone.resolve({
          cart: typeof Ev.createCartFromAjaxResponse === 'function' ? Ev.createCartFromAjaxResponse(k) : null,
          detail: {
            items: k && k.items,
            source: 'zp-szybki-wybor',
            itemCount: ilosc,
            productId: produktId,
            sections: odp && odp.sections,
            didError: !!blad
          }
        });
      }).catch(function (e) { odlozone.reject(e); });
    }

    return fetch(trasa('cart_add_url', '/cart/add.js'), {
      method: 'POST',
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd,
      credentials: 'same-origin'
    })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, dane: j }; });
      })
      .then(function (w) {
        var d = w.dane || {};
        if (d.status || !w.ok) {
          /* Shopify oddaje komunikat po polsku (np. o dostepnosci) - pokazujemy go wprost */
          return zKoszykiem(d, true).then(function () {
            throw { kod: 'sklep', tresc: d.description || d.message || T.bladOgolny };
          });
        }
        return zKoszykiem(d, false).then(function () { return d; });
      })
      .catch(function (e) {
        if (e && e.kod) throw e;
        if (odlozone) { try { odlozone.reject(e); } catch (x) { /* nic */ } }
        throw { kod: 'siec', tresc: T.bladSieci };
      });
  }

  /* ------------------------------------------------------------------ panel */

  function handleZKarty(karta) {
    var a = karta.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var h = (a.getAttribute('href') || '').split('?')[0].split('#')[0];
    var i = h.indexOf('/products/');
    if (i < 0) return null;
    h = h.slice(i + 10).split('/')[0];
    return h || null;
  }

  function kotwica(karta) {
    return karta.querySelector('.card-gallery') || karta;
  }

  /* Na dole kafelka moga byc kropki kolorow (snippet zp-kolory innego agenta).
     Podnosimy panel dokladnie nad nie, zamiast je zaslaniac. Nic tam nie zmieniamy. */
  function dopasujDol(stan) {
    var lista = stan.karta.querySelector('.zp-kolory__lista');
    if (!lista) return;
    var h = lista.getBoundingClientRect().height;
    if (!h) return;
    var dol = Math.round(h) + 14;
    if (stan.dol === dol) return;
    stan.dol = dol;
    stan.root.style.setProperty('--zp-sw-dol', dol + 'px');
  }

  function przycisk(klasa, etykieta) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = klasa;
    tekst(b, etykieta);
    return b;
  }

  function zbuduj(karta, handle) {
    var k = kotwica(karta);
    /* bez getComputedStyle w petli (24 wymuszone przeliczenia ukladu): .card-gallery motywu jest position:relative;
       innym kotwicom ustawiamy relative bez odczytu - to idempotentne */
    if (!k.classList.contains('card-gallery')) k.style.position = 'relative';

    var root = document.createElement('div');
    root.className = 'zp-sw';
    root.setAttribute('data-zp-sw', '1');

    var przelacz = przycisk('zp-sw__pigulka', T.rozmiar);
    przelacz.setAttribute('aria-expanded', 'false');
    przelacz.setAttribute('aria-label', T.wybierz);

    var panel = document.createElement('div');
    panel.className = 'zp-sw__panel';

    var naglowek = document.createElement('div');
    naglowek.className = 'zp-sw__naglowek';
    var etyk = document.createElement('span');
    etyk.className = 'zp-sw__etykieta';
    tekst(etyk, T.rozmiar);
    var zamknij = przycisk('zp-sw__zamknij', '×');
    zamknij.setAttribute('aria-label', T.zamknij);
    naglowek.appendChild(etyk);
    naglowek.appendChild(zamknij);

    var lista = document.createElement('div');
    lista.className = 'zp-sw__lista';

    var info = document.createElement('p');
    info.className = 'zp-sw__info';
    info.setAttribute('role', 'status');
    info.setAttribute('aria-live', 'polite');

    panel.appendChild(naglowek);
    panel.appendChild(lista);
    panel.appendChild(info);
    root.appendChild(przelacz);
    root.appendChild(panel);
    k.appendChild(root);

    var stan = {
      karta: karta, handle: handle, root: root, pigulka: przelacz, panel: panel,
      lista: lista, info: info, etykieta: etyk, dane: null, wczytane: false, zajete: false
    };

    przelacz.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (stan.jeden && stan.dane) { dodajZPanelu(stan, stan.jeden, przelacz); return; }
      przelaczPanel(stan, root.getAttribute('data-otwarty') !== '1');
    });
    zamknij.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      przelaczPanel(stan, false);
    });
    /* klikniecie w panel nie ma wchodzic na karte produktu */
    root.addEventListener('click', function (e) { e.stopPropagation(); });

    /* desktop: pokazujemy rozmiary po najechaniu na kafelek */
    karta.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch') return;
      dopasujDol(stan);
      wczytaj(stan);
    });
    karta.addEventListener('focusin', function () { dopasujDol(stan); wczytaj(stan); });

    karta.setAttribute('data-zp-sw-gotowe', '1');
    return stan;
  }

  function przelaczPanel(stan, otworz) {
    if (otworz) {
      zamknijWszystkie(stan);
      stan.root.setAttribute('data-otwarty', '1');
      stan.pigulka.setAttribute('aria-expanded', 'true');
      dopasujDol(stan);
      wczytaj(stan);
    } else {
      stan.root.removeAttribute('data-otwarty');
      stan.pigulka.setAttribute('aria-expanded', 'false');
    }
  }

  var wszystkie = [];

  function zamknijWszystkie(oprocz) {
    for (var i = 0; i < wszystkie.length; i++) {
      if (wszystkie[i] !== oprocz && wszystkie[i].root.getAttribute('data-otwarty') === '1') {
        wszystkie[i].root.removeAttribute('data-otwarty');
        wszystkie[i].pigulka.setAttribute('aria-expanded', 'false');
      }
    }
  }

  /* cicho = odswiezenie po bledzie sklepu; nie kasujemy wtedy komunikatu dla klientki */
  function wczytaj(stan, cicho) {
    if (stan.wczytane) { odswiezMojRozmiar(stan); return; }
    stan.wczytane = true;
    stan.root.setAttribute('data-stan', 'ladowanie');
    if (!cicho) tekst(stan.info, T.ladowanie);
    pobierz(stan.handle, function (dane) {
      stan.root.removeAttribute('data-stan');
      if (!dane || !dane.v || !dane.v.length) {
        stan.wczytane = false;
        if (!cicho) {
          tekst(stan.info, T.bladDanych);
          stan.info.setAttribute('data-blad', '1');
        }
        return;
      }
      stan.dane = dane;
      if (!cicho) {
        tekst(stan.info, '');
        stan.info.removeAttribute('data-blad');
      }
      rysuj(stan);
    });
  }

  function rysuj(stan) {
    var d = stan.dane, i, w;
    stan.lista.innerHTML = '';
    tekst(stan.etykieta, d.o || T.rozmiar);

    /* jeden wariant (albo rozmiar uniwersalny) = od razu "Dodaj do koszyka" */
    if (d.v.length === 1) {
      w = d.v[0];
      stan.jeden = { id: w[2], rozmiar: w[0], dost: !!w[1], min: w[3] || 1 };
      var opis = (uniwersalny(w[0]) || !w[0]) ? T.dodaj : (T.dodaj + ' · ' + w[0]);
      var b = przycisk('zp-sw__dodaj', w[1] ? opis : T.wyprzedane);
      b.disabled = !w[1];
      if (w[1]) {
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          dodajZPanelu(stan, stan.jeden, b);
        });
      }
      stan.lista.appendChild(b);
      tekst(stan.pigulka, w[1] ? T.dodajKrotko : T.wyprzedane);
      stan.pigulka.disabled = !w[1];
      stan.pigulka.setAttribute('aria-label', w[1] ? T.dodaj : T.wyprzedane);
      stan.root.setAttribute('data-jeden', '1');
      return;
    }

    stan.jeden = null;
    for (i = 0; i < d.v.length; i++) {
      (function (w) {
        var etykietaRozmiaru = (w[0] == null || w[0] === '') ? '–' : String(w[0]);
        var b = przycisk('zp-sw__r', etykietaRozmiaru);
        b.setAttribute('data-rozmiar', etykietaRozmiaru);
        if (!w[1]) {
          b.disabled = true;
          b.setAttribute('data-brak', '1');
          b.title = T.brakRozmiaru;
        }
        if (tenMojRozmiar(d.t, w[0])) {
          b.setAttribute('data-moj', '1');
          b.title = (b.title ? b.title + ' · ' : '') + T.twoj;
        }
        if (w[1]) {
          b.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            dodajZPanelu(stan, { id: w[2], rozmiar: w[0], dost: true, min: w[3] || 1 }, b);
          });
        }
        stan.lista.appendChild(b);
      })(d.v[i]);
    }
  }

  function odswiezMojRozmiar(stan) {
    if (!stan.dane || stan.jeden) return;
    var d = stan.dane;
    Array.prototype.forEach.call(stan.lista.querySelectorAll('.zp-sw__r'), function (b, i) {
      var w = d.v[i];
      if (!w) return;
      if (tenMojRozmiar(d.t, w[0])) b.setAttribute('data-moj', '1');
      else b.removeAttribute('data-moj');
    });
  }

  function dodajZPanelu(stan, wariant, guzik) {
    if (stan.zajete) return;
    stan.zajete = true;
    /* poprzednie sprzatanie nie moze skasowac nowego komunikatu */
    if (stan.zegar) { clearTimeout(stan.zegar); stan.zegar = null; }
    stan.root.setAttribute('data-stan', 'wysylam');
    guzik.setAttribute('data-praca', '1');
    stan.info.removeAttribute('data-blad');
    tekst(stan.info, '');

    var produktId = stan.karta.getAttribute('data-product-id') || '';

    dodaj(stan.root, wariant.id, wariant.min || 1, produktId)
      .then(function () {
        stan.zajete = false;
        stan.root.setAttribute('data-stan', 'ok');
        guzik.removeAttribute('data-praca');
        guzik.setAttribute('data-ok', '1');
        tekst(stan.info, wariant.rozmiar && !uniwersalny(wariant.rozmiar)
          ? T.dodano + ' · ' + wariant.rozmiar
          : T.dodano);
        otworzSzuflade();
        /* stan magazynowy sie zmienil - kasujemy cache i po animacji rysujemy rozmiary od nowa,
           dzieki czemu ostatnia sztuka od razu robi sie wyszarzona */
        zapomnij(stan.handle);
        stan.zegar = setTimeout(function () {
          stan.zegar = null;
          guzik.removeAttribute('data-ok');
          stan.root.removeAttribute('data-stan');
          tekst(stan.info, '');
          przelaczPanel(stan, false);
          stan.wczytane = false;
          wczytaj(stan, true);
        }, 2600);
      })
      .catch(function (b) {
        stan.zajete = false;
        stan.root.removeAttribute('data-stan');
        guzik.removeAttribute('data-praca');
        var komunikat = (b && b.tresc) || T.bladOgolny;
        stan.info.setAttribute('data-blad', '1');
        tekst(stan.info, komunikat);
        if (b && b.kod === 'sklep') {
          /* dostepnosc mogla sie zmienic - wymuszamy ponowne pobranie rozmiarow */
          zapomnij(stan.handle);
          stan.wczytane = false;
          setTimeout(function () { wczytaj(stan, true); }, 400);
        }
      });
  }

  function zapomnij(handle) {
    delete pamiec[handle];
    try { sessionStorage.removeItem(CACHE + handle); } catch (e) { /* nic */ }
    try { sessionStorage.removeItem(CACHE_MR + handle); } catch (e) { /* nic */ }
  }

  /* ----------------------------------------------------------------- montaz */

  function montuj() {
    /* Najpierw karty w zasiegu ~1,5 ekranu (to, co klientka widzi), reszta w czasie bezczynnosci -
       montaz 24 paneli naraz kosztowal ~0,6 s CPU na telefonie (Lighthouse 18.09) i blokowal pierwsze malowanie. */
    var granica = (window.innerHeight || 800) * 1.5, pozniej = [];
    Array.prototype.forEach.call(document.querySelectorAll('product-card'), function (karta) {
      if (karta.getAttribute('data-zp-sw-gotowe') === '1') return;
      if (!karta.querySelector('.card-gallery')) return;
      var h = handleZKarty(karta);
      if (!h) return;
      if (karta.getBoundingClientRect().top < granica) wszystkie.push(zbuduj(karta, h));
      else pozniej.push([karta, h]);
    });
    if (!pozniej.length) return;
    var reszta = function () {
      pozniej.forEach(function (p) {
        if (p[0].isConnected && p[0].getAttribute('data-zp-sw-gotowe') !== '1') wszystkie.push(zbuduj(p[0], p[1]));
      });
    };
    if (window.requestIdleCallback) window.requestIdleCallback(reszta, { timeout: 1500 });
    else setTimeout(reszta, 250);
  }

  function sprzataj() {
    wszystkie = wszystkie.filter(function (s) { return s.karta.isConnected; });
  }

  function start() {
    /* Bez modulu zdarzen koszyka nie da sie odswiezyc szuflady bez przeladowania strony.
       W takim razie nic nie montujemy - klientka dostaje natywny przycisk motywu. */
    if (!(Zdarzenia && Zdarzenia.CartLinesUpdateEvent)) {
      console.warn('[zp-szybki-wybor] brak @shopify/events - zostawiam natywny przycisk motywu');
      return;
    }
    montuj();

    var czeka = null;
    var obs = new MutationObserver(function () {
      if (czeka) return;
      czeka = setTimeout(function () { czeka = null; sprzataj(); montuj(); }, 120);
    });
    obs.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest || !e.target.closest('.zp-sw')) zamknijWszystkie(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') zamknijWszystkie(null);
    });
    document.addEventListener('shopify:section:load', function () {
      setTimeout(function () { sprzataj(); montuj(); }, 60);
    });
    window.addEventListener('storage', function (e) {
      if (e.key === 'zp_mr_v1') wszystkie.forEach(odswiezMojRozmiar);
    });
  }

  /* male API do testow */
  window.zpSzybkiWybor = {
    panele: function () { return wszystkie.length; },
    stan: function (handle) {
      for (var i = 0; i < wszystkie.length; i++) if (wszystkie[i].handle === handle) return wszystkie[i];
      return null;
    },
    wczytaj: function (handle) { var s = this.stan(handle); if (s) wczytaj(s); return s; },
    dodaj: dodaj,
    zdarzeniaDostepne: function () { return !!(Zdarzenia && Zdarzenia.CartLinesUpdateEvent); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
